<app-dialog-header [title]="'PAGE.MODULE_FORM.TAB.CONTENT.BUTTON.PARTICIPANTS_PROGRESS'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="position-relative" *ngIf="doughnutChartData">
        <span class="percentage"> {{ doughnutChartData.datasets[0].data[0] }}% </span>
        <canvas width="auto" height="180" baseChart [legend]="false" [data]="doughnutChartData" [type]="doughnutChartType" [options]="doughnutChartOptions"> </canvas>
    </div>
    <div fxLayoutAlign="center center">
        <span class="chart-description p-24">
            {{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.COMPLETED_SECTIONS' | translate }}
        </span>
    </div>

    <form [formGroup]="formGroup">
        <div fxLayoutAlign="space-between center">
            <div class="w-200 p-8">
                <mat-form-field class="w-100-p">
                    <mat-select formControlName="statusInput" [placeholder]="'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.FILTER_BY_STATUS' | translate">
                        <mat-option value="">{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.ALL' | translate }}</mat-option>
                        <mat-option value="completed">{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED' | translate }}</mat-option>
                        <mat-option value="inProgress">{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.IN_PROGRESS' | translate }}</mat-option>
                        <mat-option value="notStarted">{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.NOT_STARTED' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <app-search-outline [searchInput]="searchInput"></app-search-outline>
        </div>
    </form>

    <div class="p-24" fxLayout="column" fxLayoutAlign="center center" *ngIf="dataSource.showSpinner">
        <mat-spinner></mat-spinner>
    </div>
    <div [hidden]="dataSource.showSpinner" class="table-wrapper border border-gray-300">
        <table mat-table class="full-width-table tab-participants" aria-label="Elements">
            <!-- description Column -->
            <ng-container matColumnDef="description">
                <mat-cell class="tab-participants-progress" *matCellDef="let row">
                    <mat-accordion class="">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title fxLayoutAlign="start center" fxFlex="1 1 33%">
                                    <img class="avatar" *ngIf="row?.user.avatar.src; else initials" [alt]="row.user.fullName" [src]="row.user.avatar.src" />
                                    <ng-template #initials>
                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ row.user.fullName | initials }}</div>
                                    </ng-template>
                                    {{ row.user.fullName }}
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="start center">
                                    <mat-progress-bar
                                        attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                        mode="determinate"
                                        value="{{ (row.completed / row.total) * 100 }}"
                                    >
                                    </mat-progress-bar>
                                    <span class="complete-text pl-8">
                                        {{ row.completed }}/{{ row.total }} {{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED' | translate }}
                                    </span>
                                </mat-panel-description>

                                <div fxLayout="row" fxLayoutAlign="end center" *ngIf="currentModule?.type === ModuleType.ELearning">
                                    <button mat-icon-button [matMenuTriggerFor]="progressActionsMenu" aria-label="More" (click)="$event.stopPropagation()">
                                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                                    </button>

                                    <mat-menu #progressActionsMenu="matMenu" xPosition="before">
                                        <button mat-menu-item (click)="setParticipantCompletionToComplete(row)" *ngIf="getRowStatus(row) !== ModuleUserProgressStatus.Completed">
                                            <mat-icon svgIcon="tick_completed"></mat-icon>
                                            <span>{{ 'MODULE.PARTICIPANTS.ACTION.SET_TO_COMPLETE' | translate }}</span>
                                        </button>
                                        <button mat-menu-item (click)="confirmResetParticipantProgress(row)" *ngIf="getRowStatus(row) !== ModuleUserProgressStatus.NotStarted">
                                            <mat-icon>refresh</mat-icon>
                                            <span>{{ 'MODULE.PARTICIPANTS.ACTION.RESET_PROGRESS' | translate }}</span>
                                        </button>
                                    </mat-menu>
                                </div>
                            </mat-expansion-panel-header>
                            <div fxLayoutAlign="start center" class="user-sections" *ngFor="let section of row.sectionStats">
                                <span class="max-w-96 pr-24">{{ section.section?.name }}</span>
                                <span>{{
                                    section.completed
                                        ? ('PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED' | translate)
                                        : ('PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.NOT_COMPLETED' | translate)
                                }}</span>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </mat-cell>
            </ng-container>

            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </table>

        <mat-paginator persistPageSize="module.participants-progress" #paginator [length]="dataSource.totalCount$ | async" [pageSize]="dataSource.pageSize$ | async" [pageSizeOptions]="[10, 25, 50]"> </mat-paginator>
    </div>
</div>
